<template>
    <div>
        <apoios
            :apoios="apoios"
            :apoiosServicos="obterServicos()"
            :permiteInserir="$temAcessoView('GESCON-GER-APOIO-01')"
            :permiteExcluir="$temAcessoView('GESCON-GER-APOIO-01')"
            @obterApoiosAtualizados="obterApoios()"
        >
        </apoios>
    </div>
</template>

<script>
import ApoiosServicos from './ApoiosServicos'
import Apoios from './../../componentes/apoios/Apoios'

export default {
    components: {
        Apoios
    },

    data() {
        return {
            apoios: []
        }
    },

    methods: {
        obterApoios() {
            this.$store.dispatch('addRequest')
            ApoiosServicos.obterApoios().then((response) => {
                if (response) {
                    if (response.success) {
                        this.apoios = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterServicos() {
            return ApoiosServicos
        }
    },

    computed: {},

    created() {
        this.obterApoios()
    }
}
</script>
